<script lang="ts" setup>
import { Vue3ColorPicker } from '@cyhnkckali/vue3-color-picker'
import { Dropdown } from 'floating-vue'

import '@cyhnkckali/vue3-color-picker/dist/style.css'
import 'floating-vue/dist/style.css'

const pickedColor = defineModel({
  type: String,
  default: '#ff0000'
})
</script>

<template>
  <Dropdown>
    <button
      type="button"
      class="tw-aspect-square tw-w-8 tw-cursor-pointer tw-rounded-full tw-border tw-border-solid tw-border-black lg:tw-w-10"
      :style="{
        backgroundColor: pickedColor
      }"
    />

    <template #popper>
      <Vue3ColorPicker
        v-model="pickedColor"
        mode="solid"
        type="HEX"
        :show-picker-mode="false"
        :show-color-list="false"
        :show-alpha="false"
        :show-eye-drop="false"
        class="!tw-shadow-none"
      />
    </template>
  </Dropdown>
</template>
